import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
 const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

 //const token =localStorage.getItem('token');
//  return token ? children : <Navigate to="/" replace />;




  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
